import { translatedCopy } from "~/i18n/translatedCopy.ts";

type ProfileCopy = {
  title: string;
  back: string;
  imageTitle: string;
  signOut: string;
  commit: string;
  runningBuild: string;
  changePhoto: string;
  addPhoto: string;
  removePhoto: string;
  noListSelected: string;
  noListMessage: string;
  showLists: string;
  deleteAccount: string;
  deleteAccountTitle: string;
  deleteAccountBody: string;
  deleteAccountConfirm: string;
  deleteAccountCannotTitle: string;
  deleteAccountErrorTitle: string;
  deleteAccountErrorBody: string;
  deleteAccountSharedBody: string;
  preferencesTitle: string;
  wrapItemText: string;
  hideImagePlaceholder: string;
  addNewItemsOnTop: string;
  checkedItemsLast: string;
  forceSingleColumn: string;
  useDeviceLanguage: string;
  language: string;
  selectLanguage: string;
  firstName: string;
  lastName: string;
  updateName: string;
  feedbackButton: string;
  feedbackTitle: string;
  feedbackConfirm: string;
  feedbackRequired: string;
  feedbackTooLong: string;
  feedbackSentTitle: string;
  feedbackSentMessage: string;
  feedbackErrorTitle: string;
  feedbackErrorMessage: string;
};

export const profileCopy = translatedCopy<ProfileCopy>("profile");
